import React from "react";
import { Button, Tooltip, message } from "antd";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";

interface ApiClientCopyCellProps {
  /** The cell as it reads on the page. */
  children: React.ReactNode;
  /** What the clipboard receives. Without one the cell shows no copy button. */
  value?: string | null;
  /** The column's title, which names the button for assistive technology. */
  column: string;
  testId: string;
}

/** A table cell with a clipboard button that copies the cell's text, as the secret dialog does. */
function ApiClientCopyCell({ children, value = "", column, testId }: ApiClientCopyCellProps) {
  const [t] = useTranslation("global");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value ?? "");
      message.success(t("apiClients.copied"));
    } catch {
      message.error(t("apiClients.copyFailed"));
    }
  };

  if (!value) return <>{children}</>;

  const label = t("apiClients.copyColumn", { column });
  return (
    <div className="d-flex align-items-start gap-2">
      <div className="flex-grow-1">{children}</div>
      <Tooltip title={label}>
        <Button
          size="small"
          type="text"
          aria-label={label}
          data-testid={testId}
          icon={<FontAwesomeIcon icon={faClipboard} />}
          onClick={copy}
        />
      </Tooltip>
    </div>
  );
}

export default ApiClientCopyCell;
